export default __webpack_public_path__ + "static/media/label.ef7022f4.svg";